/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';

import imgComprasNet from '../../../assets/images/logo-portais/logo-comprasnet.png';
import imgLicitacoese from '../../../assets/images/logo-portais/logo-licitacoese.png';
import imgBLL from '../../../assets/images/logo-portais/logo-bll.png';
import imgBNC from '../../../assets/images/logo-portais/logo-bnc.png';
import imgLicitApp from '../../../assets/images/logo-portais/logo-licitapp.png';
import imgComprasPublicas from '../../../assets/images/logo-portais/logo-portalcompraspublicas.svg';
import imgComprasRJ from '../../../assets/images/logo-portais/logo-comprasrj.png';
import imgBanrisul from '../../../assets/images/logo-portais/logo-banrisul.png';
import imgComprasEletronicasRS from '../../../assets/images/logo-portais/logo-celic.png';
import imgPEIntegrado from '../../../assets/images/logo-portais/logo-peintegrado.png';
import imgLicitanet from '../../../assets/images/logo-portais/logo-licitanet.svg';
import imgFAMESP from '../../../assets/images/logo-portais/logo-famesp.png';
import imgSESTSENAT from '../../../assets/images/logo-portais/logo-sestsenat.png';
import imgEComprasAM from '../../../assets/images/logo-portais/logo-amazonas.png';
import imgSEPLAGMT from '../../../assets/images/logo-portais/logo-seplag.png';
import imgEComprasCuritiba from '../../../assets/images/logo-portais/logo-ecomprascuritiba.gif';
import imgComprasAp from '../../../assets/images/logo-portais/logo-compras-ap.png';
import imgLicitacoesE2 from '../../../assets/images/logo-portais/logo-licitacoese2.png';
import imgLicitarDigital from '../../../assets/images/logo-portais/logo-licitar-digital.png';
import imgItaipu from '../../../assets/images/logo-portais/logo-itaipu.png';
import imgPublinexo from '../../../assets/images/logo-portais/logo-publinexo.png';
import imgComprasManaus from '../../../assets/images/logo-portais/logo-compras-manaus.png';
import imgCemig from '../../../assets/images/logo-portais/logo-cemig.png';
import imgProcergs from '../../../assets/images/logo-portais/logo-procergs.png';
import imgAmmLicita from '../../../assets/images/logo-portais/logo-ammlicita.png';
import imgComprasCampoGrande from '../../../assets/images/logo-portais/logo-comprascampogrande.png';
import imgCentralComprasMs from '../../../assets/images/logo-portais/logo-centralcomprasms.png';
import imgComprasMa from '../../../assets/images/logo-portais/logo-comprasma.png';
import imgCopasa from '../../../assets/images/logo-portais/logo-copasa.png';
import imgBrConectado from '../../../assets/images/logo-portais/logo-brconectado.png';
import imgSelcorp from '../../../assets/images/logo-portais/logo-selcorp.png';
import imgOlimpia from '../../../assets/images/logo-portais/logo-olimpia.png';
import imgItapolis from '../../../assets/images/logo-portais/logo-itapolis.png';
import imgDemervalLobao from '../../../assets/images/logo-portais/logo-demervallobao.png';
import imgMaranhaozinho from '../../../assets/images/logo-portais/logo-maranhaozinho.png';
import imgHumbertoCampos from '../../../assets/images/logo-portais/logo-humbertocampos.png';
import imgItingaMaranhao from '../../../assets/images/logo-portais/logo-itingamaranhao.png';
import imgCajari from '../../../assets/images/logo-portais/logo-cajari.png';
import imgAnajatuba from '../../../assets/images/logo-portais/logo-anajatuba.png';
import imgSaoJoseBelmonte from '../../../assets/images/logo-portais/logo-saojosebelmonte.png';
import imgIgarapeGrande from '../../../assets/images/logo-portais/logo-igarapegrande.png';
import imgBuritiTocantins from '../../../assets/images/logo-portais/logo-burititocantins.png';
import imgTufilandia from '../../../assets/images/logo-portais/logo-tufilandia.png';
import imgSucupiraNorte from '../../../assets/images/logo-portais/logo-sucupiranorte.png';
import imgSampaio from '../../../assets/images/logo-portais/logo-sampaio.png';
import imgGrajau from '../../../assets/images/logo-portais/logo-grajau.png';
import imgIgarapeMeio from '../../../assets/images/logo-portais/logo-igarapemeio.png';
import imgSaoDomingos from '../../../assets/images/logo-portais/logo-saodomingos.png';
import imgAlcantara from '../../../assets/images/logo-portais/logo-alcantara.png';
import imgVilaNovaMartirios from '../../../assets/images/logo-portais/logo-vilanovamartirios.png';
import imgColinas from '../../../assets/images/logo-portais/logo-colinas.png';
import imgPindareMirim from '../../../assets/images/logo-portais/logo-pindaremirim.png';
import imgChaval from '../../../assets/images/logo-portais/logo-chaval.png';
import imgConceicaoLagoAcu from '../../../assets/images/logo-portais/logo-conceicaolagoacu.png';
import imgCamaraSantaFilomenaMaranhao from '../../../assets/images/logo-portais/logo-camarasantafilomenamaranhao.png';
import imgParaibano from '../../../assets/images/logo-portais/logo-paraibano.png';
import imgCentroGuilherme from '../../../assets/images/logo-portais/logo-centroguilherme.png';
import imgTuriacu from '../../../assets/images/logo-portais/logo-turiacu.png';
import imgMirador from '../../../assets/images/logo-portais/logo-mirador.png';
import imgAssembleiaLegislativaMa from '../../../assets/images/logo-portais/logo-assembleialegislativama.png';
import imgSaoJoseRibamar from '../../../assets/images/logo-portais/logo-saojoseribamar.png';
import imgSaoRoberto from '../../../assets/images/logo-portais/logo-saoroberto.png';
import imgPrimeiraCruz from '../../../assets/images/logo-portais/logo-primeiracruz.png';
import imgDavinopolis from '../../../assets/images/logo-portais/logo-davinopolis.png';
import imgMirandiba from '../../../assets/images/logo-portais/logo-mirandiba.png';
import imgSaoJoseBasilios from '../../../assets/images/logo-portais/logo-saojosebasilios.png';
import imgEsperantinopolis from '../../../assets/images/logo-portais/logo-esperantinopolis.png';
import imgLagoVerde from '../../../assets/images/logo-portais/logo-lagoverde.png';
import imgPresidenteMedici from '../../../assets/images/logo-portais/logo-presidentemedici.png';
import imgSantoAmaroMaranhao from '../../../assets/images/logo-portais/logo-santoamaromaranhao.png';
import imgBarreirinhas from '../../../assets/images/logo-portais/logo-barreirinhas.png';
import imgPeriMirim from '../../../assets/images/logo-portais/logo-perimirim.png';
import imgSantanaMaranhao from '../../../assets/images/logo-portais/logo-santanamaranhao.png';
import imgNovaOlinda from '../../../assets/images/logo-portais/logo-novaolinda.png';
import imgBelagua from '../../../assets/images/logo-portais/logo-belagua.png';
import imgUrbanoSantos from '../../../assets/images/logo-portais/logo-urbanosantos.png';
import imgPioXii from '../../../assets/images/logo-portais/logo-pioxii.png';
import imgDomingosMourao from '../../../assets/images/logo-portais/logo-domingosmourao.png';
import imgGilbues from '../../../assets/images/logo-portais/logo-gilbues.png';
import imgCarolina from '../../../assets/images/logo-portais/logo-carolina.png';
import imgMorros from '../../../assets/images/logo-portais/logo-morros.png';
import imgMontesAltos from '../../../assets/images/logo-portais/logo-montesaltos.png';
import imgZeDoca from '../../../assets/images/logo-portais/logo-zedoca.png';
import imgMarajaSena from '../../../assets/images/logo-portais/logo-marajasena.png';
import imgNovaIorque from '../../../assets/images/logo-portais/logo-novaiorque.png';
import imgCoreau from '../../../assets/images/logo-portais/logo-coreau.png';
import imgBrejo from '../../../assets/images/logo-portais/logo-brejo.png';
import imgBarreirasPiaui from '../../../assets/images/logo-portais/logo-barreiraspiaui.png';
import imgCarire from '../../../assets/images/logo-portais/logo-carire.png';
import imgMoraujo from '../../../assets/images/logo-portais/logo-moraujo.png';
import imgPalmeirais from '../../../assets/images/logo-portais/logo-palmeirais.png';
import imgMiguelLeao from '../../../assets/images/logo-portais/logo-miguelleao.png';
import imgPalmeirasTocantins from '../../../assets/images/logo-portais/logo-palmeirastocantins.png';
import imgAmapaMaranhao from '../../../assets/images/logo-portais/logo-amapamaranhao.png';
import imgJati from '../../../assets/images/logo-portais/logo-jati.png';
import imgOeiras from '../../../assets/images/logo-portais/logo-oeiras.png';
import imgCamaraBarraCorda from '../../../assets/images/logo-portais/logo-camarabarracorda.png';
import imgCamaraLagoPedra from '../../../assets/images/logo-portais/logo-camaralagopedra.png';
import imgCamaraPrimeiraCruz from '../../../assets/images/logo-portais/logo-camaraprimeiracruz.png';
import imgCamaraSaoJoseBelmonte from '../../../assets/images/logo-portais/logo-camarasaojosebelmonte.png';
import imgCamaraBrejo from '../../../assets/images/logo-portais/logo-camarabrejo.png';
import imgCamaraBarreirinhas from '../../../assets/images/logo-portais/logo-camarabarreirinhas.png';
import imgSaaeOeiras from '../../../assets/images/logo-portais/logo-saaeoeiras.png';
import imgFIEMG from '../../../assets/images/logo-portais/logo-fiemg.png';
import imgBbmnet from '../../../assets/images/logo-portais/logo-bbmnet.png';
import imgLicitaMa from '../../../assets/images/logo-portais/logo-licitama.png';
import imgPortalSiades from '../../../assets/images/logo-portais/logo-portalsiades.png';
import imgSenhorBonfim from '../../../assets/images/logo-portais/logo-senhorbonfim.png';
import imgCampoFormoso from '../../../assets/images/logo-portais/logo-campoformoso.png';
import imgJaguarari from '../../../assets/images/logo-portais/logo-jaguarari.png';
import imgPindobacu from '../../../assets/images/logo-portais/logo-pindobacu.png';
import imgFiladelfia from '../../../assets/images/logo-portais/logo-filadelfia.png';
import imgCaldeiraoGrande from '../../../assets/images/logo-portais/logo-caldeiraogrande.png';
import imgSaude from '../../../assets/images/logo-portais/logo-saude.png';
import imgBaixaGrande from '../../../assets/images/logo-portais/logo-baixagrande.png';
import imgPontoNovo from '../../../assets/images/logo-portais/logo-pontonovo.png';
import imgAntonioGoncalves from '../../../assets/images/logo-portais/logo-antoniogoncalves.png';
import imgVarzeaNova from '../../../assets/images/logo-portais/logo-varzeanova.png';
import imgVarzeaPoco from '../../../assets/images/logo-portais/logo-varzeapoco.png';
import imgItiuba from '../../../assets/images/logo-portais/logo-itiuba.png';
import imgCamaraCampoFormoso from '../../../assets/images/logo-portais/logo-camaracampoformoso.png';
import imgCamaraPontoNovo from '../../../assets/images/logo-portais/logo-camarapontonovo.png';
import imgCamaraItiuba from '../../../assets/images/logo-portais/logo-camaraitiuba.png';
import imgCamaraSenhorBonfim from '../../../assets/images/logo-portais/logo-camarasenhorbonfim.png';
import imgCamaraJaguarari from '../../../assets/images/logo-portais/logo-camarajaguarari.png';
import imgCamaraCaldeiraoGrande from '../../../assets/images/logo-portais/logo-camaracaldeiraogrande.png';
import imgCpisSenhorBonfim from '../../../assets/images/logo-portais/logo-cpissenhorbonfim.png';
import imgCdsTpni from '../../../assets/images/logo-portais/logo-cdstpni.png';

import { Container } from './styles';

interface PortalOption {
  name: string;
  img: string;
  strong?: boolean;
  source_id?: number;
  monitoring?: boolean;
}

export interface PortalImageProps {
  imgSize?: string;
  className?: string;
  source_id?: number;
  alt?: string;
}

interface MonitoringPortalsListProps {
  cardSize: string;
  imgSize: string;
  monitoring?: boolean;
  featuredIds?: number[];
}

export const FEATURED_PORTAL_IDS: number[] = [
  677,  // BLL Compras
  3926, // Bolsa Nacional de Compras (BNC)
  781,  // Banrisul
  1107, // BBMNET
  2263, // Compras RJ
  146,  // ComprasNet
  6759, // ComprasNet DL
  177,  // Licitações-e
  5204, // Licitanet
  7225, // Licitações-E2
];

export const PORTALS: PortalOption[] = [
  { name: 'ComprasNet', strong: true, img: imgComprasNet, source_id: 146, monitoring: true},
  { name: 'ComprasNet DL', strong: false, img: imgComprasNet, source_id: 6759, monitoring: true},
  { name: 'Licitações-e', strong: true, img: imgLicitacoese, source_id: 177, monitoring: true},
  { name: 'Licitações-E2', strong: false, img: imgLicitacoesE2, source_id: 7225, monitoring: true},
  { name: 'Portal de Compras Publicas', strong: true, img: imgComprasPublicas, source_id: 857, monitoring: true},
  { name: 'Licitar Digital', strong: false, img: imgLicitarDigital, source_id: 6304, monitoring: true},
  { name: 'Amm Licita', strong: false, img: imgAmmLicita, source_id: 7249, monitoring: true},
  { name: 'BLL Compras', strong: true, img: imgBLL, source_id: 677, monitoring: true},
  { name: 'Bolsa Nacional de Compras (BNC)', strong: true, img: imgBNC, source_id: 3926, monitoring: true},
  { name: 'Licitanet', strong: true, img: imgLicitanet, source_id: 5204, monitoring: true},
  { name: 'PE Integrado', strong: true, img: imgPEIntegrado, source_id: 3871, monitoring: true},
  { name: 'LicitApp', strong: true, img: imgLicitApp, source_id: 7543, monitoring: true},
  { name: 'Banrisul', strong: true, img: imgBanrisul, source_id: 781, monitoring: true},
  { name: 'Compras Eletrônicas RS', strong: true, img: imgComprasEletronicasRS, source_id: 4632, monitoring: true},
  { name: 'Procergs', strong: true, img: imgProcergs, source_id: 2072, monitoring: true},
  { name: 'E-Compras AM', strong: false, img: imgEComprasAM, source_id: 809, monitoring: true},
  { name: 'E-Compras SEST SENAT', strong: false, img: imgSESTSENAT, source_id: 2934, monitoring: true},
  { name: 'Compras RJ', strong: true, img: imgComprasRJ, source_id: 2263, monitoring: true},
  { name: 'Aquisições SEPLAG MT', strong: false, img: imgSEPLAGMT, source_id: 6212, monitoring: true},
  { name: 'e-Compras Curitiba', strong: false, img: imgEComprasCuritiba, source_id: 2080, monitoring: true},
  { name: 'Portal de Compras Eletrônicas - Itaipu Binacional', strong: false, img: imgItaipu, source_id: 1354, monitoring: true},
  { name: 'Compras FAMESP', strong: false, img: imgFAMESP, source_id: 2050, monitoring: true},
  { name: 'Portal de Compras PUBLINEXO', strong: false, img: imgPublinexo, source_id: 2104, monitoring: true},
  { name: 'Portal de Compras Manaus', strong: false, img: imgComprasManaus, source_id: 6740, monitoring: true},
  { name: 'Cemig', strong: false, img: imgCemig, source_id: 871, monitoring: true},
  { name: 'Compras Campo Grande', strong: false, img: imgComprasCampoGrande, source_id: 7154, monitoring: true},
  { name: 'Central de Compras MS', strong: false, img: imgCentralComprasMs, source_id: 1477, monitoring: true},
  { name: 'Compras AP (SIGA)', strong: false, img: imgComprasAp, source_id: 5646, monitoring: true},
  { name: 'Compras MA (SIGA)', strong: false, img: imgComprasMa, source_id: 5082, monitoring: true},
  { name: 'Copasa MG', strong: false, img: imgCopasa, source_id: 3157, monitoring: true},
  { name: 'Br Conectado', strong: false, img: imgBrConectado, source_id: 7016, monitoring: true},
  { name: 'Selcorp', strong: false, img: imgSelcorp, source_id: 6571, monitoring: true},
  { name: 'Prefeitura Municipal de Olimpia - SP', strong: false, img: imgOlimpia, source_id: 3516, monitoring: true},
  { name: 'Prefeitura Municipal de Itápolis - SP', strong: false, img: imgItapolis, source_id: 2471, monitoring: true},
  { name: 'Assembleia Legislativa do Estado do Maranhão', strong: false, img: imgAssembleiaLegislativaMa, source_id: 1266, monitoring: true},
  { name: 'Prefeitura Municipal de Demerval Lobão - PI', strong: false, img: imgDemervalLobao, source_id: 7338, monitoring: true},
  { name: 'Prefeitura Municipal de Maranhaozinho - MA', strong: false, img: imgMaranhaozinho, source_id: 7339, monitoring: true},
  { name: 'Prefeitura Municipal de Humberto de Campos - MA', strong: false, img: imgHumbertoCampos, source_id: 7340, monitoring: true},
  { name: 'Prefeitura Municipal de Itinga do Maranhão - MA', strong: false, img: imgItingaMaranhao, source_id: 5729, monitoring: true},
  { name: 'Prefeitura Municipal de Cajari - MA', strong: false, img: imgCajari, source_id: 7100, monitoring: true},
  { name: 'Prefeitura Municipal de Anajatuba - MA', strong: false, img: imgAnajatuba, source_id: 7341, monitoring: true},
  { name: 'Prefeitura Municipal de São José do Belmonte - PE', strong: false, img: imgSaoJoseBelmonte, source_id: 7342, monitoring: true},
  { name: 'Prefeitura Municipal de Igarape Grande - MA', strong: false, img: imgIgarapeGrande, source_id: 7343, monitoring: true},
  { name: 'Prefeitura Municipal de Buriti do Tocantins - TO', strong: false, img: imgBuritiTocantins, source_id: 6762, monitoring: true},
  { name: 'Prefeitura Municipal de Tufilandia - MA', strong: false, img: imgTufilandia, source_id: 7052, monitoring: true},
  { name: 'Prefeitura Municipal de Sucupira do Norte - MA', strong: false, img: imgSucupiraNorte, source_id: 7344, monitoring: true},
  { name: 'Prefeitura Municipal de Sampaio - TO', strong: false, img: imgSampaio, source_id: 7345, monitoring: true},
  { name: 'Prefeitura Municipal de Grajau - MA', strong: false, img: imgGrajau, source_id: 7346, monitoring: true},
  { name: 'Prefeitura Municipal de Igarape do Meio - MA', strong: false, img: imgIgarapeMeio, source_id: 7347, monitoring: true},
  { name: 'Prefeitura Municipal de São Domingos - MA', strong: false, img: imgSaoDomingos, source_id: 7348, monitoring: true},
  { name: 'Prefeitura Municipal de Alcantara - MA', strong: false, img: imgAlcantara, source_id: 7349, monitoring: true},
  { name: 'Prefeitura Municipal de Vila Nova dos Martirios - MA', strong: false, img: imgVilaNovaMartirios, source_id: 7350, monitoring: true},
  { name: 'Prefeitura Municipal de Colinas - MA', strong: false, img: imgColinas, source_id: 7351, monitoring: true},
  { name: 'Prefeitura Municipal de Pindaré Mirim - MA', strong: false, img: imgPindareMirim, source_id: 7352, monitoring: true},
  { name: 'Prefeitura Municipal de Chaval - CE', strong: false, img: imgChaval, source_id: 7353, monitoring: true},
  { name: 'Prefeitura Municipal de Lago Açu - MA', strong: false, img: imgConceicaoLagoAcu, source_id: 7354, monitoring: true},
  { name: 'Prefeitura Municipal de Paraibano - MA', strong: false, img: imgParaibano, source_id: 7356, monitoring: true},
  { name: 'Prefeitura Municipal de Centro do Guilherme - MA', strong: false, img: imgCentroGuilherme, source_id: 7357, monitoring: true},
  { name: 'Prefeitura Municipal de Turiaçu - MA', strong: false, img: imgTuriacu, source_id: 7091, monitoring: true},
  { name: 'Prefeitura Municipal de Mirador - MA', strong: false, img: imgMirador, source_id: 7358, monitoring: true},
  { name: 'Prefeitura Municipal de São José de Ribamar - MA', strong: false, img: imgSaoJoseRibamar, source_id: 3267, monitoring: true},
  { name: 'Prefeitura Municipal de São Roberto - MA', strong: false, img: imgSaoRoberto, source_id: 7359, monitoring: true},
  { name: 'Prefeitura Municipal de Primeira Cruz - MA', strong: false, img: imgPrimeiraCruz, source_id: 7360, monitoring: true},
  { name: 'Prefeitura Municipal de Davinópolis - MA', strong: false, img: imgDavinopolis, source_id: 6595, monitoring: true},
  { name: 'Prefeitura Municipal de Mirandiba - PE', strong: false, img: imgMirandiba, source_id: 7367, monitoring: true},
  { name: 'Prefeitura Municipal de São José dos Basílios - MA', strong: false, img: imgSaoJoseBasilios, source_id: 7448, monitoring: true},
  { name: 'Prefeitura Municipal de Esperantinópolis - MA', strong: false, img: imgEsperantinopolis, source_id: 7449, monitoring: true},
  { name: 'Prefeitura Municipal de Lago Verde - MA', strong: false, img: imgLagoVerde, source_id: 7450, monitoring: true},
  { name: 'Prefeitura Municipal de Presidente Médici - MA', strong: false, img: imgPresidenteMedici, source_id: 7451, monitoring: true},
  { name: 'Prefeitura Municipal de Santo Amaro do Maranhão - MA', strong: false, img: imgSantoAmaroMaranhao, source_id: 7452, monitoring: true},
  { name: 'Prefeitura Municipal de Barreirinhas - MA', strong: false, img: imgBarreirinhas, source_id: 7453, monitoring: true},
  { name: 'Prefeitura Municipal de Peri Mirim - MA', strong: false, img: imgPeriMirim, source_id: 7454, monitoring: true},
  { name: 'Prefeitura Municipal de Santana do Maranhão - MA', strong: false, img: imgSantanaMaranhao, source_id: 7455, monitoring: true},
  { name: 'Prefeitura Municipal de Nova Olinda do Maranhão - MA', strong: false, img: imgNovaOlinda, source_id: 7456, monitoring: true},
  { name: 'Prefeitura Municipal de Belágua - MA', strong: false, img: imgBelagua, source_id: 7457, monitoring: true},
  { name: 'Prefeitura Municipal de Urbano Santos - MA', strong: false, img: imgUrbanoSantos, source_id: 7458, monitoring: true},
  { name: 'Prefeitura Municipal de Pio XII - MA', strong: false, img: imgPioXii, source_id: 7380, monitoring: true},
  { name: 'Prefeitura Municipal de Domingos Mourão - MA', strong: false, img: imgDomingosMourao, source_id: 7459, monitoring: true},
  { name: 'Prefeitura Municipal de Gilbués - PI', strong: false, img: imgGilbues, source_id: 7460, monitoring: true},
  { name: 'Prefeitura Municipal de Carolina - MA', strong: false, img: imgCarolina, source_id: 4428, monitoring: true},
  { name: 'Prefeitura Municipal de Morros - MA', strong: false, img: imgMorros, source_id: 6637, monitoring: true},
  { name: 'Prefeitura Municipal de Montes Altos - MA', strong: false, img: imgMontesAltos, source_id: 7461, monitoring: true},
  { name: 'Prefeitura Municipal de Zé Doca - MA', strong: false, img: imgZeDoca, source_id: 3105, monitoring: true},
  { name: 'Prefeitura Municipal de Marajá do Sena - MA', strong: false, img: imgMarajaSena, source_id: 7409, monitoring: true},
  { name: 'Prefeitura Municipal de Nova Iorque - MA', strong: false, img: imgNovaIorque, source_id: 7462, monitoring: true},
  { name: 'Prefeitura Municipal de Coreaú - CE', strong: false, img: imgCoreau, source_id: 7463, monitoring: true},
  { name: 'Prefeitura Municipal de Brejo - MA', strong: false, img: imgBrejo, source_id: 7464, monitoring: true},
  { name: 'Prefeitura Municipal de Barreiras do Piauí - PI', strong: false, img: imgBarreirasPiaui, source_id: 7465, monitoring: true},
  { name: 'Prefeitura Municipal de Cariré - CE', strong: false, img: imgCarire, source_id: 7466, monitoring: true},
  { name: 'Prefeitura Municipal de Moraújo - CE', strong: false, img: imgMoraujo, source_id: 7467, monitoring: true},
  { name: 'Prefeitura Municipal de Palmeirais - PI', strong: false, img: imgPalmeirais, source_id: 7468, monitoring: true},
  { name: 'Prefeitura Municipal de Miguel Leão - PI', strong: false, img: imgMiguelLeao, source_id: 7469, monitoring: true},
  { name: 'Prefeitura Municipal de Palmeiras do Tocantins - TO', strong: false, img: imgPalmeirasTocantins, source_id: 7470, monitoring: true},
  { name: 'Prefeitura Municipal de Amapá do Maranhão - MA', strong: false, img: imgAmapaMaranhao, source_id: 7471, monitoring: true},
  { name: 'Prefeitura Municipal de Jati - CE', strong: false, img: imgJati, source_id: 7472, monitoring: true},
  { name: 'Prefeitura Municipal de Oeiras - PI', strong: false, img: imgOeiras, source_id: 7473, monitoring: true},
  { name: 'Câmara Municipal de Santa Filomena - MA', strong: false, img: imgCamaraSantaFilomenaMaranhao, source_id: 7355, monitoring: true},
  { name: 'Câmara Municipal de Barra do Corda - MA', strong: false, img: imgCamaraBarraCorda, source_id: 7474, monitoring: true},
  { name: 'Câmara Municipal de Lago da Pedra - MA', strong: false, img: imgCamaraLagoPedra, source_id: 7475, monitoring: true},
  { name: 'Câmara Municipal de Primeira Cruz - MA', strong: false, img: imgCamaraPrimeiraCruz, source_id: 7476, monitoring: true},
  { name: 'Câmara Municipal de São José do Belmonte - PE', strong: false, img: imgCamaraSaoJoseBelmonte, source_id: 7477, monitoring: true},
  { name: 'Câmara Municipal de Brejo - MA', strong: false, img: imgCamaraBrejo, source_id: 7478, monitoring: true},
  { name: 'Câmara Municipal de Barreirinhas - MA', strong: false, img: imgCamaraBarreirinhas, source_id: 7479, monitoring: true},
  { name: 'Serviço Autônomo de Água e Esgoto do Município de Oeiras - PI', strong: false, img: imgSaaeOeiras, source_id: 7480, monitoring: true},
  { name: 'BBMNET', strong: false, img: imgBbmnet, source_id: 1107, monitoring: true},
  { name: 'Portal de Compra Licita MA', strong: false, img: imgLicitaMa, source_id: 7642, monitoring: true},
  { name: 'SIADES - Sistema Administrativo Digital do ES', strong: false, img: imgPortalSiades, source_id: 7640, monitoring: true},
  { name: 'Prefeitura Municipal de Senhor do Bonfim - BA', strong: false, img: imgSenhorBonfim, source_id: 730, monitoring: true},
  { name: 'Prefeitura Municipal de Campo Formoso - BA', strong: false, img: imgCampoFormoso, source_id: 6970, monitoring: true},
  { name: 'Prefeitura Municipal de Jaguarari - BA', strong: false, img: imgJaguarari, source_id: 6611, monitoring: true},
  { name: 'Prefeitura Municipal de Pindobaçu - BA', strong: false, img: imgPindobacu, source_id: 6569, monitoring: true},
  { name: 'Prefeitura Municipal de Filadélfia - BA', strong: false, img: imgFiladelfia, source_id: 7612, monitoring: true},
  { name: 'Prefeitura Municipal de Caldeirão Grande - BA', strong: false, img: imgCaldeiraoGrande, source_id: 7613, monitoring: true},
  { name: 'Prefeitura Municipal de Saúde - BA', strong: false, img: imgSaude, source_id: 7610, monitoring: true},
  { name: 'Prefeitura Municipal de Baixa Grande - BA', strong: false, img: imgBaixaGrande, source_id: 6267, monitoring: true},
  { name: 'Prefeitura Municipal de Ponto Novo - BA', strong: false, img: imgPontoNovo, source_id: 6882, monitoring: true},
  { name: 'Prefeitura Municipal de Antônio Gonçalves - BA', strong: false, img: imgAntonioGoncalves, source_id: 6552, monitoring: true},
  { name: 'Prefeitura Municipal de Várzea Nova - BA', strong: false, img: imgVarzeaNova, source_id: 7614, monitoring: true},
  { name: 'Prefeitura Municipal de Várzea do Poço - BA', strong: false, img: imgVarzeaPoco, source_id: 7615, monitoring: true},
  { name: 'Prefeitura Municipal de Itiúba - BA', strong: false, img: imgItiuba, source_id: 6940, monitoring: true},
  { name: 'Câmara Municipal de Campo Formoso - BA', strong: false, img: imgCamaraCampoFormoso, source_id: 7616, monitoring: true},
  { name: 'Câmara Municipal de Ponto Novo - BA', strong: false, img: imgCamaraPontoNovo, source_id: 7617, monitoring: true},
  { name: 'Câmara Municipal de Itiúba - BA', strong: false, img: imgCamaraItiuba, source_id: 7618, monitoring: true},
  { name: 'Câmara Municipal de Senhor do Bonfim - BA', strong: false, img: imgCamaraSenhorBonfim, source_id: 7619, monitoring: true},
  { name: 'Câmara Municipal de Jaguarari - BA', strong: false, img: imgCamaraJaguarari, source_id: 7620, monitoring: true},
  { name: 'Câmara Municipal de Caldeirão Grande - BA', strong: false, img: imgCamaraCaldeiraoGrande, source_id: 7621, monitoring: true},
  { name: 'Consórcio Público Interfederativo de Saúde de Senhor do Bonfim - BA', strong: false, img: imgCpisSenhorBonfim, source_id: 7611, monitoring: true},
  { name: 'CDS Território Piemonte Norte do Itapicuru - BA', strong: false, img: imgCdsTpni, source_id: 7622, monitoring: true},
];

const byId = new Map<number, PortalOption>(
  PORTALS.filter(p => typeof p.source_id === 'number').map(p => [p.source_id as number, p])
);

function getPortalBySourceId(sourceId?: number): PortalOption | undefined {
  if (!sourceId) return undefined;
  return byId.get(sourceId);
}

export function PortalImage({ imgSize = '27px', className = '', source_id, alt }: PortalImageProps) {
  const option = useMemo(() => getPortalBySourceId(source_id), [source_id]);
  const label = alt ?? option?.name ?? 'Portal desconhecido';
  const [src, setSrc] = useState(option?.img);

  if (!option || !src) return null;

  return (
    <Container className={`inline-block ${className}`} title={label} aria-label={label}>
      <img
        src={src}
        alt={label}
        style={{ maxHeight: imgSize, width: 'auto' }}
        className="mb-0 block rounded"
        onError={() => setSrc(undefined)}
      />
    </Container>
  );
}

export default function MonitoringPortalsList({ cardSize, imgSize, monitoring, featuredIds}: MonitoringPortalsListProps) {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const portalsToDisplay = useMemo(() => {
    let list = [...PORTALS];
    if (profile?.beta_tester) {
      list.push({ name: 'FieMg', strong: false, img: imgFIEMG });
    }

    list = list.filter(portal => portal.monitoring === true);
    list.sort((a, b) => a.name.localeCompare(b.name));

    if (featuredIds?.length) {
      const rank = (portal: PortalOption) => {
        const position = portal.source_id ? featuredIds.indexOf(portal.source_id) : -1;
        if (position >= 0) return position;

        return featuredIds.length + (portal.strong ? 0 : 1);
      };

      list.sort((a, b) => rank(a) - rank(b) || a.name.localeCompare(b.name));
    }

    return list;
  }, [profile?.beta_tester, monitoring, featuredIds]);

  return (
    <div className="row align-items-stretch justify-content-center mb-2">
      {portalsToDisplay.map((option, index) => (
        <div
          key={`${option.name}-${option.source_id || index}`}
          className={`bg-white ${cardSize} rounded border text-center py-3 px-2 m-2 d-flex align-items-center flex-wrap justify-content-center`}
        >
          <Container>
            <img
              src={option.img}
              alt={option.name}
              style={{ maxHeight: imgSize }}
              className="mb-2 img-logos"
            />
            <p className="m-0 w-100">{option.name}</p>
          </Container>
        </div>
      ))}
    </div>
  );
}